import React from 'react';
import GoogleMap from './google-maps/GoogleMap';
import { locationsData } from './locationsData';
import './locations.css';
const Locations = () => {
	return (
		<React.Fragment>
			<h1 className="find-gym-typography">Find a Gym Near You</h1>
			<div className="gym-container">
				<div className="gym-locator-container">
					{locationsData.map((item) => {
						return (
							<div key={item.id} className="gym-locator" onClick={() => console.log(item.lat, item.lng)}>
								<h3>{item.location}</h3>
								<p>{item.storeHour}</p>
								<p>{item.address}</p>
								<p>
									{item.city}, {item.state}
								</p>
								<p>{item.phoneNumber}</p>
							</div>
						);
					})}
				</div>
				<div className="google-maps-location-container">
					<GoogleMap />
				</div>
			</div>
		</React.Fragment>
	);
};

export default Locations;
